import { HttpEventType, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { LoadingService } from '../services/loading.service';
import { inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { tap } from 'rxjs';

let pendingRequests = 0;
let routerSubscribed = false;

/**
 * This list contains the endpoints that should be excluded from triggering
 * the loading spinner in the interceptor. Add any future endpoints that
 * should bypass the loading indicator here.
 */
const excludedEndpoints: string[] = [
  'check-cookie',
  'auth/logout',
  'country',
  'locations/all',
  'events',
  'locker-locations/all',
  'confirm-phone-number/:phoneNumber',
  'confirm-phone-number/verify/:code',
  'settings/customer-insights',
  'support/log-entry',
  'v2/user/keys-and-puc',
  'user',
  'locations/',
  'terminals/'
  // Add more endpoints to exclude as needed
];


export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  // Subscribe once to router events to align spinner with navigation
  if (!routerSubscribed) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        loadingService.showLoading();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        // Only hide if no active HTTP requests tracked by this interceptor
        if (pendingRequests === 0) {
          loadingService.hideLoading();
        }
      }
    });
    routerSubscribed = true;
  }

  // Check if the current request should be excluded from showing the loading spinner
  const isExcluded = excludedEndpoints.length > 0 && excludedEndpoints.some(endpoint => req.url.includes(endpoint));
  
  if (isExcluded) {
    return next(req);
  }

  loadingService.showLoading();
  pendingRequests++;

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event.type === HttpEventType.Response) {
          handleHideLoading(loadingService);
        }
      },
      error: (_) => {
        handleHideLoading(loadingService);
      }
    })
  );
};

function handleHideLoading(loadingService: LoadingService) {
  pendingRequests--;
  if (pendingRequests === 0) {
    loadingService.hideLoading();
  }
}